import React from "react";
import { useNavigate } from "react-router-dom";
import {
  FaArrowLeft,
  FaTools,
  FaBlender,
  FaFire,
  FaClock,
  FaPhoneAlt,
  FaHome,
  FaCogs,
} from "react-icons/fa";

const HomeAppliance = ({
  serviceName = "Mixer Repair",
  shortDescription = "We are currently preparing this appliance repair module. Soon you will be able to book trusted technicians for inspection, repair, and maintenance.",
  statusTitle = "We’ll Get Back Soon",
  statusDescription = "This appliance repair booking is not live yet. We are working on service flow, technician onboarding, and schedule support to launch it with the same smooth experience as your other service pages.",
}) => {
  const navigate = useNavigate();

  const getServiceIcon = () => {
    const name = serviceName.toLowerCase();

    if (name.includes("mixer") || name.includes("blender") || name.includes("grinder")) {
      return <FaBlender />;
    }
    if (name.includes("oven") || name.includes("microwave")) {
      return <FaFire />;
    }
    return <FaTools />;
  };

  const styles = {
    page: {
      minHeight: "100vh",
      background: "linear-gradient(135deg, #f4f8ff 0%, #edf5ff 100%)",
      padding: "24px 0 40px",
      fontFamily: "Segoe UI, Tahoma, Geneva, Verdana, sans-serif",
    },
    container: {
      width: "98%",
      maxWidth: "1450px",
      margin: "0 auto",
    },
    hero: {
      background: "linear-gradient(135deg, #0f172a, #1d4ed8, #38bdf8)",
      color: "#fff",
      borderRadius: "26px",
      padding: "30px",
      boxShadow: "0 18px 42px rgba(29, 78, 216, 0.22)",
      marginBottom: "24px",
    },
    badge: {
      display: "inline-block",
      padding: "7px 14px",
      borderRadius: "999px",
      background: "rgba(255,255,255,0.12)",
      fontSize: "13px",
      fontWeight: "700",
      marginBottom: "14px",
      color: "#fff",
    },
    heroTitle: {
      margin: 0,
      fontSize: "2rem",
      fontWeight: "800",
      display: "flex",
      alignItems: "center",
      gap: "12px",
      flexWrap: "wrap",
      color: "#fff",
    },
    heroSub: {
      marginTop: "10px",
      marginBottom: 0,
      color: "rgba(255,255,255,0.9)",
      fontSize: "1rem",
      maxWidth: "760px",
    },
    topBtn: {
      border: "none",
      borderRadius: "999px",
      padding: "11px 18px",
      fontWeight: "700",
      background: "#fff",
      color: "#1d4ed8",
      boxShadow: "0 8px 20px rgba(255,255,255,0.18)",
      cursor: "pointer",
    },
    summaryCard: {
      background: "#fff",
      borderRadius: "22px",
      padding: "22px",
      boxShadow: "0 10px 26px rgba(15, 23, 42, 0.08)",
      border: "1px solid #eaf0f8",
      height: "100%",
    },
    summaryTitle: {
      fontSize: "15px",
      fontWeight: "700",
      color: "#475569",
      marginBottom: "8px",
    },
    summaryValue: {
      fontSize: "1.9rem",
      fontWeight: "800",
      color: "#111827",
      marginBottom: "8px",
    },
    summaryText: {
      margin: 0,
      color: "#6b7280",
      fontSize: "14px",
    },
    contentCard: {
      background: "#fff",
      borderRadius: "26px",
      boxShadow: "0 14px 34px rgba(15, 23, 42, 0.08)",
      border: "1px solid #ebf1f8",
      overflow: "hidden",
      maxWidth: "1350px",
      margin: "0 auto",
      padding: "32px",
    },
    statusBox: {
      background: "linear-gradient(135deg, #eff6ff, #f8fbff)",
      border: "1px solid #dbeafe",
      borderRadius: "22px",
      padding: "32px",
      textAlign: "center",
      marginBottom: "24px",
    },
    iconCircle: {
      width: "78px",
      height: "78px",
      borderRadius: "50%",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      margin: "0 auto 16px",
      background: "linear-gradient(135deg, #dbeafe, #bfdbfe)",
      color: "#1d4ed8",
      fontSize: "30px",
    },
    statusTitle: {
      fontSize: "2rem",
      fontWeight: "800",
      color: "#0f172a",
      marginBottom: "10px",
    },
    statusSub: {
      color: "#475569",
      fontSize: "16px",
      maxWidth: "760px",
      margin: "0 auto",
      lineHeight: 1.7,
    },
    noteBox: {
      background: "#ffffff",
      border: "1px solid #dbeafe",
      borderRadius: "18px",
      padding: "18px 20px",
      color: "#334155",
      fontSize: "15px",
      marginBottom: "20px",
    },
    featureCard: {
      background: "#f8fbff",
      border: "1px solid #e6eef8",
      borderRadius: "18px",
      padding: "20px",
      height: "100%",
    },
    featureIcon: {
      width: "46px",
      height: "46px",
      borderRadius: "12px",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      background: "#eaf2ff",
      color: "#1d4ed8",
      marginBottom: "12px",
      fontSize: "18px",
    },
    featureTitle: {
      fontSize: "18px",
      fontWeight: "800",
      color: "#111827",
      marginBottom: "8px",
    },
    featureText: {
      margin: 0,
      color: "#6b7280",
      fontSize: "14px",
      lineHeight: 1.7,
    },
    actionRow: {
      display: "flex",
      gap: "14px",
      flexWrap: "wrap",
      marginTop: "24px",
      justifyContent: "center",
    },
    primaryBtn: {
      border: "none",
      background: "linear-gradient(135deg, #1d4ed8, #2563eb)",
      color: "#fff",
      borderRadius: "999px",
      padding: "13px 22px",
      fontWeight: "800",
      minWidth: "190px",
      boxShadow: "0 10px 22px rgba(37,99,235,0.22)",
      cursor: "pointer",
    },
    secondaryBtn: {
      border: "1px solid #cbd5e1",
      background: "#fff",
      color: "#1d4ed8",
      borderRadius: "999px",
      padding: "13px 22px",
      fontWeight: "800",
      minWidth: "190px",
      cursor: "pointer",
    },
  };

  return (
    <div style={styles.page}>
      <div style={styles.container}>
        <div style={styles.hero}>
          <div className="row align-items-center g-3">
            <div className="col-lg-8">
              <span style={styles.badge}>Service Update</span>
              <h2 style={styles.heroTitle}>
                {getServiceIcon()}
                {serviceName}
              </h2>
              <p style={styles.heroSub}>{shortDescription}</p>
            </div>

            <div className="col-lg-4 text-lg-end">
              <button style={styles.topBtn} onClick={() => navigate(-1)}>
                <FaArrowLeft className="me-2" />
                Back
              </button>
            </div>
          </div>
        </div>

        <div className="row g-4 mb-4">
          <div className="col-md-4">
            <div style={styles.summaryCard}>
              <div style={styles.summaryTitle}>Service Category</div>
              <div style={styles.summaryValue}>{serviceName}</div>
              <p style={styles.summaryText}>
                Inspection, diagnosis, repair and basic maintenance support for your home appliance needs.
              </p>
            </div>
          </div>

          <div className="col-md-4">
            <div style={styles.summaryCard}>
              <div style={styles.summaryTitle}>Current Status</div>
              <div style={styles.summaryValue}>Coming Soon</div>
              <p style={styles.summaryText}>
                This appliance repair page is under preparation and will be enabled shortly.
              </p>
            </div>
          </div>

          <div className="col-md-4">
            <div style={styles.summaryCard}>
              <div style={styles.summaryTitle}>Response Note</div>
              <div style={styles.summaryValue}>We’ll Get Back</div>
              <p style={styles.summaryText}>
                Once activated, you can request service with appliance issue details and preferred visit schedule.
              </p>
            </div>
          </div>
        </div>

        <div style={styles.contentCard}>
          <div style={styles.statusBox}>
            <div style={styles.iconCircle}>{getServiceIcon()}</div>
            <div style={styles.statusTitle}>{statusTitle}</div>
            <p style={styles.statusSub}>{statusDescription}</p>
          </div>

          <div style={styles.noteBox}>
            This page is intentionally kept simple so users clearly understand that
            this appliance repair service is not available for booking yet, while
            still matching the same visual design system as your other service pages.
          </div>

          <div className="row g-4">
            <div className="col-md-4">
              <div style={styles.featureCard}>
                <div style={styles.featureIcon}>
                  <FaCogs />
                </div>
                <div style={styles.featureTitle}>Issue Diagnosis Setup</div>
                <p style={styles.featureText}>
                  Fault types, service steps, and repair issue categories are currently being prepared.
                </p>
              </div>
            </div>

            <div className="col-md-4">
              <div style={styles.featureCard}>
                <div style={styles.featureIcon}>
                  <FaClock />
                </div>
                <div style={styles.featureTitle}>Schedule Availability</div>
                <p style={styles.featureText}>
                  Technician schedules and time slots will be added once the module is ready to go live.
                </p>
              </div>
            </div>

            <div className="col-md-4">
              <div style={styles.featureCard}>
                <div style={styles.featureIcon}>
                  <FaHome />
                </div>
                <div style={styles.featureTitle}>Home Service Support</div>
                <p style={styles.featureText}>
                  Users will soon be able to request doorstep appliance service with address and visit preferences.
                </p>
              </div>
            </div>
          </div>

          <div style={styles.actionRow}>
            <button style={styles.primaryBtn} onClick={() => navigate(-1)}>
              <FaArrowLeft className="me-2" />
              Go Back
            </button>

            <button
              style={styles.secondaryBtn}
              type="button"
              onClick={() => navigate("/support")}
            >
              <FaPhoneAlt className="me-2" />
              Contact Support
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HomeAppliance;